import { AuthConfig } from '@auth0/auth0-angular';
import { AuthCacheService } from '../app/services/auth-cache.service';
import { getTenantFromUrl } from '../app/shared/util/helpers/url.helper';

const cId = 'TxCBLeU3zI6AKmbGgMudHu87V918pWNl';
const tenant = getTenantFromUrl();
const appUrl = 'https://supplierportal-development.agridence.com';

export const environment = {
  name: 'Development',
  production: false,
  CRD_API: 'https://api-traceability-crd-development.agridence.com/api/',
  GCP_API: 'https://console-one-development.agridence.com',
  USER_CONFIG:
    'https://assets.agridence.com/configs/development/{tenantId}/config.json',
  posthogApiKey: 'phc_NMIi98nvCxMFry1oys6hGDagws4j623XorKRHjAHSXp',
  posthogHost: 'https://us.i.posthog.com',
  supplierPortalAuth0: {
    domain: 'https://id-development.agridence.com',
    clientId: cId,
    authorizationParams: {
      redirect_uri: `${appUrl}/auth/callback`,
      audience: 'com.agridence.traceability.supplierportal',
      organization: tenant ?? '',
      scope: 'openid profile email offline_access'
    },
    cache: new AuthCacheService(),
    useRefreshTokens: true,
    errorPath: `${appUrl}/error`
  } satisfies AuthConfig,
  appUrl: appUrl,
  mapboxToken:
    'pk.eyJ1IjoiYnJ5YW5oYyIsImEiOiJjbG5lN2hhd3IwZHA0MnNtamFvenpqMjR5In0.v6IJPRIgSL1cjD2WMI75VA',
  sentry: {
    enabled: true,
    dsn: 'https://8f7c2e4615ae9fcf7e049ee2254b497a@o4510859648892928.ingest.de.sentry.io/4510989770489936',
    debug: true
  }
};
